import AbstractApi from "services/cores/abstractApi";
import paths from "routes/paths";

const ParkedCarsApi = new AbstractApi({
  paths: {
    default: paths.api.parkStatistics.dataByRadius.parkedCars,
    byAreas: paths.api.parkStatistics.dataByAreas.parkedCars,
    byRadius: paths.api.parkStatistics.dataByRadius.parkedCars,
  },
});

export default ParkedCarsApi;
